/**
 * Check for salesEnd or salesEnded in propKey
 **/
export const isSalesEndPropKey = (propKey) => {
    if (propKey === 'salesEnd' || propKey === 'salesEnded') {
        return true;
    }
    return false;
};
